"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.docComplete = void 0;
const docComplete = handleDocumentComplete => {
  if (typeof window && document) {
    document.removeEventListener('readystatechange', handleDocumentComplete);
    if (document.readyState === 'interactive') {
      document.addEventListener('readystatechange', handleDocumentComplete, false);
    } else {
      setTimeout(handleDocumentComplete, 2);
    }
  }
};
exports.docComplete = docComplete;

//# sourceMappingURL=docComplete.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@att-bit/ui-frameworks.components.analytics-event/dist/docComplete.js
// module id = 564
// module chunks = 8